import React from 'react'
import Helmet from 'react-helmet'
import BooksSection from '../components/BooksSection.js'
import TalksSection from '../components/TalksSection.js'

import powerful from '../assets/images/powerful.jpg'
import trustInfographic from '../assets/images/trust-infographic.png'
import buildRebuildTrustThumbnail from '../assets/images/build-rebuild-trust-thumbnail.jpg'
import goodLeadersThumbnail from '../assets/images/why-good-leaders-thumbnail.jpg'
import bodyLanguageThumbnail from '../assets/images/body-language-thumbnail.jpg'
import trustWorksCover from '../assets/images/trust-works-cover.jpg'
import trust from '../assets/images/trust.png'

const books = [
  {
    title: 'Powerful',
    link:
      'https://www.amazon.com/Powerful-Building-Culture-Freedom-Responsibility/dp/1939714095',
    description:
      'When it comes to recruiting, motivating, and creating great teams, Patty McCord says most companies have it all wrong. McCord helped create the unique and high-performing culture at Netflix, where she was chief talent officer. In her new book, Powerful: Building a Culture of Freedom and Responsibility, she shares what she learned there and elsewhere in Silicon Valley.',
    image: {
      src: powerful,
      alt: 'Powerful book cover'
    }
  },
  {
    title: 'Trust Works!',
    link:
      'https://www.amazon.com/dp/0062205986/ref=cm_sw_su_dp?tag=harpercollinsus-20',
    description:
      'Trust Works!: Four Keys to Building Lasting Relationships is an insightful guide designed to help people navigate one of the most complex issues that affects all areas of our lives: trust.',
    image: {
      src: trustWorksCover,
      alt: 'Trust Works! book cover'
    }
  }
]

const talks = [
  {
    title: 'How to build and rebuild trust',
    link:
      'https://www.ted.com/talks/frances_frei_how_to_build_and_rebuild_trust',
    description:
      'Trust is the foundation for everything we do. But what do we do when it\'s broken? In an eye-opening talk, Harvard Business School professor Frances Frei gives a crash course in trust: how to build it, maintain it and rebuild it -- something she worked on during a recent stint at Uber. "If we can learn to trust one another more, we can have unprecedented human progress," Frei says.',
    image: {
      src: buildRebuildTrustThumbnail,
      alt: 'How to build and rebuild trust video thumbnail'
    }
  },
  {
    title: 'Why good leaders make you feel safe',
    link:
      'https://www.ted.com/talks/simon_sinek_why_good_leaders_make_you_feel_safe',
    description:
      'What makes a great leader? Management theorist Simon Sinek suggests, it’s someone who makes their employees feel secure, who draws staffers into a circle of trust. But creating trust and safety — especially in an uneven economy — means taking on big responsibility.',
    image: {
      src: goodLeadersThumbnail,
      alt: 'Why good leaders make you feel safe video thumbnail'
    }
  },
  {
    title: 'Your body language may shape who you are',
    link:
      'https://www.ted.com/talks/amy_cuddy_your_body_language_shapes_who_you_are',
    description:
      'Body language affects how others see us, but it may also change how we see ourselves. Social psychologist Amy Cuddy argues that "power posing" — standing in a posture of confidence, even when we don\'t feel confident — can boost feelings of confidence, and might have an impact on our chances for success.',
    image: {
      src: bodyLanguageThumbnail,
      alt: 'Your body language may shape who you are video thumbnail'
    }
  }
]

const BuildingTrust = () => (
  <div>
    <section id="one" className="main style1">
      <div className="grid-wrapper">
        <div className="col-6">
          <header className="major">
            <h2>Building Trust</h2>
          </header>
          <p>
            Ensuring that your people look upon you with respect by doing the
            following:
          </p>
          <ul>
            <li>Instilling pride in people for being associated with you</li>
            <li>Communicate openly</li>
            <li>Going beyond your self-interest for the good of the group</li>
            <li>Keep your promises</li>
            <li>Acting in ways that builds others respect for you</li>
            <li>Being fair and reliable (authentic, transparent and honest)</li>
          </ul>
        </div>
        <div className="col-6">
          <span className="image fit">
            <img src={trust} alt="Group of people holding hands in sign of trust" />
          </span>
        </div>
      </div>
    </section>

    <section id="four" className="main style3 special">
      <header className="major">
        <h2>Check Lists</h2>
      </header>
      <div className="grid-wrapper">
        <div className="col-3"></div>

        <div className="col-6">
          <ul className="uniform" style={{ listStyle: 'square', textAlign: 'left' }}>
            <li>
              <a target="_blank" href="https://drive.google.com/open?id=1xMDRvxfZMNoZ4WlV39QLH-TyNP-_bwyb">How can I have the best 1:1 meetings?</a>
            </li>
            <li>
              <a target="_blank" href="https://naspers.udemy.com/active-listening/learn/v4/overview">How can I become an active listener?</a>
            </li>
            <li>
              <a target="_blank" href="#">Do I communicate enough?</a>
            </li>
            <li><a target="_blank" href="https://drive.google.com/open?id=171m2yVo-ZnyyczzdYp6v68ArbQ2fC85F">How should I give feedback?</a></li>
            <li>
              <a target="_blank" href="https://leadingwithtrust.com/2018/06/24/do-your-leaders-build-or-erode-trust-infographic/">Build trust model - ABCD</a>
            </li>
          </ul>
        </div>
        <div className="col-3"></div>
      </div>
    </section>

    <section id="five" className="main style1">
      <div className="grid-wrapper">
        <div className="col-6">
          <header className="major">
            <h2>Templates</h2>
          </header>
          <h4>10 ways to earn the trust and respect of your team:</h4>
          <ol>
            <li>Be transparent with motives and goals.</li>
            <li>
              Demonstrate your character and intention to do the right thing for
              your team.
            </li>
            <li>Put the team's needs before your own.</li>
            <li>
              Help employees grow by letting them test, learn and fail without
              fear.
            </li>
            <li>
              Trust employees of the bat, don't make them feel they have to earn
              it.
            </li>
            <li>Let yourself be vulnerable, and admit to mistakes.</li>
            <li>
              Use inclusive words like "we" to show that you're part of the
              team, not above it.
            </li>
            <li>
              Ask for feedback and take action quickly where change is needed.
            </li>
            <li>Be yourself - people respond best to authenticity.</li>
            <li>
              Be open to learning from your team - everyone will have something
              to teach you.
            </li>
          </ol>
        </div>
        <div className="col-6">
          <span className="image fit">
            <img src={trustInfographic} alt="" />
          </span>
        </div>
      </div>
    </section>

    <section id="six" className="main style3 special">
      <header className="major">
        <h2>Guiding Questions</h2>
      </header>
      <div className="grid-wrapper">
        <div className="col-6">
          <h4 className="highlight-title-dark">For Managers:</h4>
          <ul style={{ textAlign: 'left' }}>
            <li>How would I describe my relationship with my team?</li>
            <li>Do I feel like I can trust my team?</li>
            <li>Do I feel like I can be transparent with my team?</li>
            <li>Do I encourage my team to give me their opinion?</li>
            <li>
              Do I give my team enough freedom to decide how they can do their
              work?
            </li>
            <li>Can I count on my team when I need help?</li>
            <li>Do I and my team collaborate together?</li>
            <li>How do I use 1:1 meetings to connect with my team?</li>
            <li>On a scale of 1 to 20, how is my relationship with my team?</li>
            <li>
              Do I feel that trust issues are affecting my team’s productivity?
            </li>
            <li>Do I delegate important task to my team members?</li>
          </ul>
        </div>

        <div className="col-6">
          <h4 className="highlight-title-light">By Manager to a Team Member:</h4>
          <ul style={{ textAlign: 'left' }}>
            <li>Do you feel like you can trust me?</li>
            <li>Do you feel like you can share honest thoughts with me?</li>
            <li>Do you trust the rest of the team?</li>
            <li>How can we improve as a team?</li>
            <li>What can we do to make you more successful?</li>
            <li>
              Is there any part of your job where you want more help or
              coaching?
            </li>
            <li>Are you happy working here?</li>
            <li>How do you feel your work/life balance is right now?</li>
          </ul>
        </div>
      </div>
    </section>

    <section id="three" className="main style1 special">
      <div className="grid-wrapper">
        <div className="col-12">
          <header className="major">
            <h2>Learning Materials</h2>
          </header>
        </div>

        <div className="col-4">
          <h3>What should happen in a 1:1 meeting?</h3>
          <ul style={{ textAlign: 'left' }}>
            <li>
              Reading: Asking open ended questions helps new managers build
              trust
            </li>
            <li>MyAcademy: Active Listening Masterclass</li>
          </ul>
        </div>
        <div className="col-4">
          <h3>
            What can I do to improve trust?<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </h3>
          <ul style={{ textAlign: 'left' }}>
            <li>
              Reading I: Want your employees to trust you? Show you trust them
            </li>
            <li>Reading II: What to do when you don't trust your team?</li>
            <li>MyAcademy: Buildind Trust w/ Employees (by Vado)</li>
          </ul>
        </div>
        <div className="col-4">
          <h3>How can I assess my leadership model?</h3>
          <ul style={{ textAlign: 'left' }}>
            <li>
              Assessing your Leadership Mode - quiz (we should transform the
              quiz in an online one)
            </li>
          </ul>
        </div>
      </div>
    </section>

    <BooksSection id="eight" books={books} darkBg={true} />

    <TalksSection id="seven" talks={talks} />
  </div>
)

export default BuildingTrust



// WEBPACK FOOTER //
// ./src/pages/building-trust.js